import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import type { ApiCountry, ApiOrganization } from '@agunity/api-v4';

import AgSummaryCards, { ToastListProps } from '../../../stories/Components/Cards/AgSummaryCards';
import AgTypography from '../../../stories/Styles/AgTypography';

import edit_square from '../../../stories/assets/edit_square.svg';
import { useAppDispatch } from '../../../redux/hooks';
import { getCountries } from '../../../redux/slices/countries';
import AgChip from '../../../stories/Chips/AgChip';

const SummaryCardPage = ({
  orgDetails,
  setSelectedCard,
  numberOfOrgDetailsMandatoryAll,
  numberOfOrgDetailsMandatoryCompleted,
  orgDetailsToastList,
  missingMandatoryFields_orgDetails,
  settings,
  numberOfSettingsMandatoryAll,
  numberOfSettingsMandatoryCompleted,
  settingsToastList,
  missingMandatoryFields_settings,
}: {
  orgDetails?: ApiOrganization;
  setSelectedCard?: Dispatch<SetStateAction<number>>;
  numberOfOrgDetailsMandatoryAll?: number;
  numberOfOrgDetailsMandatoryCompleted?: number;
  orgDetailsToastList?: ToastListProps[];
  missingMandatoryFields_orgDetails?: string[];
  settings?: any;
  numberOfSettingsMandatoryAll?: number;
  numberOfSettingsMandatoryCompleted?: number;
  settingsToastList?: ToastListProps[];
  missingMandatoryFields_settings?: string[];
}) => {
  const messages = useIntl().formatMessage;
  const dispatch = useAppDispatch();
  const [selectedCountry, setSelectedCountry] = useState<ApiCountry>();
  const [countries, setCountries] = useState<ApiCountry[]>();
  
  const orgTableData = [
    { 
      name: messages({ id: 'CERTIFICATION_ORG_NAME' }),
      value: orgDetails?.name ?? ''
    },
    { 
      name: messages({ id: 'MEMBER_PERSONAL_DETAILS_COUNTRY' }),
      value: selectedCountry?.name ?? ''
    },
  ];

  const settingsData = [
    { 
      name: messages({ id: 'PARENT_ORGANIZATION' }),
      value: settings.parentOrg ? <AgChip onClick={() => {}} type='organizations' label={settings.parentOrg} /> : ''
    },
    { 
      name: messages({ id: 'ORGANIZATION_TYPE' }),
      value: settings.orgType ? <AgChip onClick={() => {}} type='organizations' label={settings.orgType} /> : ''
    },
  ];

  useEffect(() => {
    const f = async () => {
      try {
        if (!countries || countries?.length === 0) {
          const cou = await dispatch(getCountries());
          if (cou?.data?.length) {
            const countryList = cou.data;
            setCountries(countryList);
          }
        }
        if (countries?.length && orgDetails?.address?.countryId) {
          const countryObj = countries.find(country => country.id === orgDetails?.address?.countryId);
          countryObj && setSelectedCountry(countryObj);
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err);
      }
    };
    f();
  }, [countries, dispatch, orgDetails?.address?.countryId]);

  return (
    <AgTypography style={{ padding: '16px', display: 'grid', gap: '12px' }}>
      <AgSummaryCards
        tableData={orgTableData}
        numberOfAllFields={numberOfOrgDetailsMandatoryAll}
        numberOfFinishedFields={numberOfOrgDetailsMandatoryCompleted}
        title={messages({ id: 'ORGANIZATION_DETAILS' })}
        btnLabel={messages({ id: 'EDIT' })}
        btnIcon={<img src={edit_square} alt='' />}
        btnOnClick={() => {
          setSelectedCard && setSelectedCard(0);
        }}
        toastList={orgDetailsToastList}
        missingMandatoryFields={missingMandatoryFields_orgDetails}
      />
      <AgSummaryCards
        tableData={settingsData}
        numberOfAllFields={numberOfSettingsMandatoryAll}
        numberOfFinishedFields={numberOfSettingsMandatoryCompleted}
        title={messages({ id: 'SETTINGS' })}
        toastList={settingsToastList}
        missingMandatoryFields={missingMandatoryFields_settings}
      />
    </AgTypography>
  );
};
 
export default SummaryCardPage;